// DSGVO/GDPR — Einwilligung für KI-gestützte Dokumentenanalyse.
//
// Die Universal-KI-Pipeline lädt CSV/PDF/Bild-Inhalte zur Analyse an
// Google Gemini (Drittland-Übermittlung, Google Cloud DPA / EU SCCs).
// Vor dem ersten Upload muss der User aktiv einwilligen — die Einwilligung
// wird unter users/{uid}.aiConsent gespeichert (Zeitstempel + Version).
//
// Bei Änderungen am Datenfluss CONSENT_VERSION erhöhen → User muss neu
// einwilligen.

import { doc, getDoc, setDoc, serverTimestamp } from '../lib/fsCompat';
import { db } from '../firebase';

export const CONSENT_VERSION = 1;

export async function getAiConsent(uid) {
  if (!uid) return null;
  try {
    const snap = await getDoc(doc(db, 'users', uid));
    const data = snap.exists() ? snap.data() : null;
    const consent = data?.aiConsent;
    if (!consent || consent.version !== CONSENT_VERSION) return null;
    return consent;
  } catch (err) {
    console.warn('[aiConsent] Lookup fehlgeschlagen:', err.message);
    return null;
  }
}

export async function grantAiConsent(uid) {
  if (!uid) return false;
  try {
    await setDoc(
      doc(db, 'users', uid),
      {
        aiConsent: {
          version:   CONSENT_VERSION,
          grantedAt: serverTimestamp(),
        },
      },
      { merge: true }
    );
    return true;
  } catch (err) {
    console.warn('[aiConsent] Speichern fehlgeschlagen:', err.message);
    return false;
  }
}

export async function revokeAiConsent(uid) {
  if (!uid) return false;
  try {
    await setDoc(
      doc(db, 'users', uid),
      { aiConsent: null },
      { merge: true }
    );
    return true;
  } catch (err) {
    console.warn('[aiConsent] Widerruf fehlgeschlagen:', err.message);
    return false;
  }
}
